export const elmoExperimentResourceNames = {
  default: 'GOPS_smarthelp',
  pcc: 'GOPS_smarthelp_pcc',
  kmSearch: 'GOPS_smarthelp_km_search',
  pendingDisputes: 'GOPS_smarthelp_pending_disputes_alert',
  resCenterLabel: 'GOPS_smarthelp_res_center_label',
  kmFullSearch: 'GOPS_smarthelp_km_full_search',
  newCallusDesign: 'GOPS_Helpcenter_New_CallUs',
  nnaDesign: 'CustomerSupport:NNAExperiances',
  updateContextPrompt: 'GOPS_smarthelp_Update_context_prompt',
};

export const elmoTreatmentNames = {
  kmSearchEnabled: 'Trmt_GOPS_Helpcenter_KM_Search_Enable',
  pendingDisputesNotification: 'Trmt_GOPS_Helpcenter_Pending_Disputes_Alert_Show',
  resCenterDisputesLabel: 'Trmt_GOPS_Helpcenter_RES_CENTER_disputes',
  resCenterCasesLabel: 'Trmt_GOPS_Helpcenter_RES_CENTER_cases',
  resCenterIssuesLabel: 'Trmt_GOPS_Helpcenter_RES_CENTER_issues',
  resCenterRefundLabel: 'Trmt_GOPS_Helpcenter_RES_CENTER_refund',
  kmFullSearchEnabled: 'Trmt_GOPS_Helpcenter_KM_Full_Search_Enable',
  newCallusDesignEnabled: 'Trmt_GOPS_Helpcenter_New_CallUs_design',
  nnaEnabled: 'Trmt_CustomerSupportR_NNAExperiances_By_Channel',
  updateContextTreatment: 'Trmt_GOPS_Helpcenter_Update_Context_prompt_Exp',
};

export const isPartOfElmoExpTreatment = (elmoTreatments, treatmentName) => (Array.isArray(elmoTreatments) && elmoTreatments.indexOf(treatmentName) >= 0);
